'use strict';/* global define */define('modules/users/directives/multi-email-input/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope", "_"];
function controller($scope,_){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.isFocused=false;ctrl.list=$scope.list||[];ctrl.exclude=$scope.exclude||[];ctrl.addEmail=addEmail;ctrl.removeEmail=removeEmail;// ---
/**
     * Add a new entry to collection
     *
     * @param {Object} email - string to be added to the list
     *
     * @tested
     */function addEmail(email){var item=_.find(ctrl.list,function(item){return item===email;});item=item||_.find(ctrl.exclude,function(item){return item===email;});if(!item){ctrl.list.push(email);}}/**
     * Remove an entry from the collection
     *
     * @param  {string} email - string to be removed
     *
     * @tested
     */function removeEmail(email){_.remove(ctrl.list,function(item){return item===email;});}}module.exports=controller;});
